<template>
  <div class="live2d">
    <div class="container" ref="container">
      <div class="bg">
        <div v-if="!showLh" class="center" :style="{ background: bgMap[attrValue] }"></div>
      </div>
      <div id="__spine_player_container__" v-if="!showLh"></div>
      <div class="lh-container" v-else>
        <img :src="dataSource.lh.value" alt="" />
      </div>
    </div>
    <div class="mask" @click="executeAnimation(1)">
      <div class="empty" v-if="isEmpty && !mainLive2d.loading">
        <img src="@/assets/zs_imgs/empty-img.png" alt="" />
        <div>资料暂时空缺，留言让版主加急</div>
      </div>
      <div class="loading" v-if="mainLive2d.loading">
        <div class="loader">
          <span class="item"></span>
          <span class="item"></span>
          <span class="item"></span>
          <span class="item"></span>
        </div>
        <div class="text">正在加载中哦</div>
      </div>
    </div>
    <div class="btns">
      <!--        <div class="btn" @click="goAiDraw">-->
      <!--          <img class="ai-draw" src="@/assets/zs_imgs/ai_draw_enter_icon.svg" alt=""/>-->
      <!--        </div>-->
      <!-- <div class="btn" @click="openVideo">
          <img src="@/assets/zs_imgs/live2d-video-icon.png" alt="" />
        </div> -->
      <div class="btn" @click="handleZoomChange">
        <el-tooltip effect="dark" :content="isZoomIn ? '小图' : '大图'" placement="top">
          <img v-if="!isZoomIn" src="@/assets/zs_imgs/live2d-zoom-in-icon.png" alt="" />
          <img v-else src="@/assets/zs_imgs/live2d-zoom-out-icon.png" alt="" />
        </el-tooltip>
      </div>
      <div class="btn" @click="openLh">
        <el-tooltip content="立绘" placement="top">
          <img src="@/assets/zs_imgs/live2d-image-icon.png" alt="" />
        </el-tooltip>
      </div>
      <div class="btn" @click="downloadLh">
        <el-tooltip content="立绘下载" placement="top">
          <img src="@/assets/zs_imgs/live2d-download-icon.png" alt="" />
        </el-tooltip>
      </div>
    </div>
    <!-- 显示立绘 -->
    <el-dialog
      title=""
      fullscreen
      append-to-body
      custom-class="lh-dialog"
      :visible.sync="lhVisible"
      :after-close="closeLh"
    >
      <div class="lh-container">
        <img :src="dataSource.lh.value" alt="" />
      </div>
    </el-dialog>
    <!-- 显示技能视频 -->
    <el-dialog
      title=""
      fullscreen
      append-to-body
      custom-class="video-dialog"
      :visible.sync="videoVisible"
      :after-close="closeVideo"
    >
      <div class="video-container">
        <video :src="videoSrc" controls autoplay muted></video>
      </div>
    </el-dialog>

    <!-- 显示live2d -->
    <el-dialog
      title=""
      fullscreen
      append-to-body
      custom-class="live2d-dialog"
      :visible.sync="live2dVisible"
      :after-close="closeLive2d"
    >
      <div class="live2d-container" id="__dialog_spine_player_container__" @click="executeAnimation(2)"></div>
    </el-dialog>

    <!-- live2d引导提示 -->
    <!--<div class="guide-box" ref="guide" v-if="!hasViewZsca2Live2dGuide1">
      <canvas ref="guideCanvas" @click="onViewGuide"></canvas>
      <div class="guide-content" ref="guideContent" @click="onViewGuide">
        <img class="click-icon" src="@/assets/zs_imgs/click-handler-icon.png" alt=""/>
        <img class="line-icon" src="@/assets/zs_imgs/line-to-icon.png" alt=""/>
        <div class="dot"></div>
        <div class="tips">点击服装，满满互动！</div>
        <div class="btn" @click="onViewGuide">立即体验</div>
      </div>
    </div>-->
    <!-- live2d 鼠标引导 -->
    <!-- <div class="cursor-guide-box" v-if="!hasViewZsca2Live2dGuide1 && !isLh">
      <div class="live2d_animation">
        <i class="cursor-icon"></i>
      </div>
    </div> -->
  </div>
</template>

<script>
import { loadScript, loadCSS } from "@/plugins/util";

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    attrValue: {
      type: String,
      default: ""
    },
    videoSrc: {
      type: String,
      default: ""
    },
    showLh: {
      type: Boolean,
      default: false
    },
    isShowLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isZoomIn: true,
      lhVisible: false,
      live2dVisible: false,
      petalEffect: null,
      isLh: true,
      videoVisible: false,
      isEmpty: false,
      hasViewZsca2Live2dGuide1: false,
      mainLive2d: {
        container: "__spine_player_container__",
        loading: false,
        spinePlayer: null
      },
      viewLive2d: {
        container: "__dialog_spine_player_container__",
        loading: false,
        spinePlayer: null
      },
      bgMap: {
        火: "#A23939",
        水: "#4076AE",
        光: "#A27339",
        风: "#236B2B",
        暗: "#5C40AE"
      },
      animationTimer: null
    };
  },
  watch: {
    dataSource: {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          // 初始化
          this.init();
        });
      }
      // deep: true
    }
  },
  mounted() {
    if (!this.showLh) {
      loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.css?t=10001`);
      loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.js?t=10001`).then(() => {
        // 初始化
        this.init();
      });
    }
  },
  deactivated() {
    if (this.animationTimer) clearInterval(this.animationTimer);
    this.lhVisible = false;
    this.live2dVisible = false;
    this.videoVisible = false;
  },
  beforeDestroy() {
    if (this.animationTimer) clearInterval(this.animationTimer);
  },
  methods: {
    init() {
      this.initSpine(this.mainLive2d);

      // 互动引导
      this.hasViewZsca2Live2dGuide1 = localStorage.getItem("hasViewZsca2Live2dGuide1");
      // if (!this.hasViewZsca2Live2dGuide1) {
      //   window.scrollTo(0, 220);
      //   this.$nextTick(() => {
      //     document.body.style.overflow = "hidden";
      //     this.coverGuide(this.$refs.guide, this.$refs.container);
      //   });
      // }
    },
    async initSpine(live2d, isView) {
      live2d.loading = true;
      const container = document.getElementById(live2d.container);
      let data = this.dataSource.source.value;

      if (typeof data === "object") {
        if (!data.json) {
          live2d.loading = false;
          return;
        }
        this.isEmpty = false;
        this.isLh = false;
        // 默认主视图放大
        let viewport = {
          x: -450,
          y: -1180,
          width: 900,
          height: 1600,
          padLeft: "5%",
          padRight: "5%",
          padTop: "5%",
          padBottom: "5%"
        };
        // 预览视图
        if (isView) {
          viewport = {
            x: -550,
            y: -650,
            width: 1200,
            height: 1200,
            padLeft: "5%",
            padRight: "5%",
            padTop: "5%",
            padBottom: "5%"
          };
        }
        // 主视图缩小
        if (!this.isZoomIn && !isView) {
          viewport = {
            x: -950,
            y: -1500,
            width: 2000,
            height: 2000,
            padLeft: "5%",
            padRight: "5%",
            padTop: "5%",
            padBottom: "5%"
          };
        }
        // console.log(data);
        try {
          // 将贴图转为黑色替换为base64
          const imageTrans = [];
          if (data.image && this.isShowLimit) {
            const images = data.image.split(",");
            images.forEach(url => {
              imageTrans.push(this.imageToBlackBase64(this.foramtUrl(url)));
            });
          }
          // 并发请求
          const resList = await Promise.all([fetch(data.json), ...imageTrans]);
          // spine数据源
          let rawDataURIs = {};
          // spine动画列表
          let animations = [];
          // 获取json数据
          const jsonData = await resList[0].json();
          // 将json数据转为base64数据，
          // tips: 有时候会出现错误，先不用转为base64
          // const jsonBase64 = btoa(unescape(encodeURIComponent(JSON.stringify(jsonData))));
          animations = Object.keys(jsonData.animations);
          // 注入到数据源中，jsonUrl请求时会使用此数据，防止重新请求
          // rawDataURIs[this.foramtUrl(data.json)] = "data:application/json;base64," + jsonBase64;

          // 将转为黑色的贴图，注入到数据源中
          if (data.image && this.isShowLimit) {
            const images = data.image.split(",");
            images.forEach((url, index) => {
              const res = resList[index + 1];
              rawDataURIs[this.foramtUrl(url)] = res;
            });
          }

          // console.log(animations, rawDataURIs);
          container.innerHTML = null;
          // 初始化;
          // eslint-disable-next-line
          new window.spine_4_1_54.SpinePlayer(container, {
            // Relative URLs
            jsonUrl: this.foramtUrl(data.json),
            atlasUrl: this.foramtUrl(data.atlas),
            animations: animations,
            showLoading: false,
            showControls: false,
            alpha: true,
            backgroundColor: "#00000000",
            viewport: viewport,
            rawDataURIs: rawDataURIs,
            success: player => {
              live2d.loading = false;
              live2d.spinePlayer = Object.seal(player);
              // console.log(player);
              // 开启动画5s循环
              this.loopToAnimation();
              if (isView) {
                this.initViewLive2dScale();
              }
            }
          });
        } catch (error) {
          this.isEmpty = true;
        }
      } else if (data) {
        live2d.loading = false;
        this.isEmpty = false;
        this.isLh = true;
        container.innerHTML = `<img class="lh-img" src="${data}" alt="" />`;
      } else {
        live2d.loading = false;
        this.isEmpty = true;
        this.isLh = false;
      }
    },
    imageToBlackBase64(url) {
      return new Promise(resolve => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          // 绘制原图到Canvas
          ctx.drawImage(img, 0, 0);

          // 获取像素数据
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          // 遍历像素，设置为全黑（RGB=0）
          for (let i = 0; i < data.length; i += 4) {
            data[i] = 0; // R
            data[i + 1] = 0; // G
            data[i + 2] = 0; // B
            // Alpha通道保持不变
          }
          // 将处理后的数据重新绘制到Canvas
          ctx.putImageData(imageData, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.src = url;
      });
    },
    executeAnimation(type) {
      // 每次执行先清除
      if (this.animationTimer) {
        clearTimeout(this.animationTimer);
        this.animationTimer = null;
      }
      if (type === 1) {
        const { spinePlayer } = this.mainLive2d;
        this.changeAnimation(spinePlayer);
      } else if (type === 2) {
        const { spinePlayer } = this.viewLive2d;
        this.changeAnimation(spinePlayer);
      }
    },
    changeAnimation(spinePlayer) {
      if (spinePlayer) {
        const animations = spinePlayer.animationState.data.skeletonData.animations;
        // 获取到motion动画
        const motionAnimation = animations.find(item => {
          return item.name === "motion";
        });
        spinePlayer.setAnimation("motion", false);
        setTimeout(() => {
          spinePlayer.setAnimation("idle", true);
          // 继续执行
          this.loopToAnimation();
        }, motionAnimation.duration * 1000);
      }
    },
    loopToAnimation() {
      if (this.animationTimer) clearInterval(this.animationTimer);
      this.animationTimer = setTimeout(() => {
        this.executeAnimation(1);
      }, 5000);
    },
    foramtUrl(url) {
      if (url.startsWith("//")) {
        return `${location.protocol}${url}`;
      } else {
        return url;
      }
    },
    openLh() {
      this.lhVisible = true;
    },
    closeLh() {
      this.lhVisible = false;
    },
    downloadLh() {
      const link = document.createElement("a");
      link.href = this.dataSource.lh.value;
      // link.download = filename || "image.jpg"; // 默认文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    openVideo() {
      this.videoVisible = true;
    },
    closeVideo() {
      this.videoVisible = false;
    },
    goAiDraw() {
      if (window.staticFn) {
        window.staticFn.customEvent("visit_AI_drawing");
      }
      let { params } = this.$route;
      let id = params.id.split("_")[0];
      this.$router.push(`/${this.alias}/ai-draw/1?id=${id}`);
    },
    handleZoomChange() {
      this.isZoomIn = !this.isZoomIn;
      this.initSpine(this.mainLive2d);
    },
    openLive2d() {
      this.live2dVisible = true;
      this.$nextTick(() => {
        this.initSpine(this.viewLive2d, true);
      });
    },
    // 滚轮缩放 位置平移
    initViewLive2dScale() {
      const spineContainer = document.getElementById(this.viewLive2d.container);
      const canvas = spineContainer.querySelector(".spine-player-canvas");
      canvas.style.height = "450vh";
      canvas.style.transform = "translateX(0) translateY(-178vh) scale(0.5)";
      spineContainer.style.overflow = "hidden";
      const container = spineContainer.querySelector("canvas");
      const vh = window.innerHeight / 100;
      let scale = 0.5;
      const zoomFactor = 0.05;
      let isDragging = false;
      let startX, startY;
      let offsetX = 0,
        offsetY = -178 * vh;

      // 滚轮缩放
      container.addEventListener("wheel", function(event) {
        event.preventDefault();

        // 计算鼠标相对于容器的位置（用于缩放中心点）
        const rect = container.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;

        // 保存缩放前的鼠标在变换空间中的位置
        const oldX = (mouseX - offsetX) / scale;
        const oldY = (mouseY - offsetY) / scale;

        // 调整缩放比例
        const delta = event.deltaY > 0 ? -1 : 1;
        scale *= 1 + delta * zoomFactor;
        scale = Math.min(Math.max(0.1, scale), 3);

        // 计算新的偏移量，使鼠标位置保持不变
        // offsetX = mouseX - oldX * scale;
        // offsetY = mouseY - oldY * scale;

        // console.log(mouseX, mouseY, oldX, oldY, offsetX, offsetY);

        updateTransform();
      });

      // 拖动平移
      container.addEventListener("mousedown", function(event) {
        isDragging = true;
        startX = event.clientX - offsetX;
        startY = event.clientY - offsetY;
      });

      document.addEventListener("mousemove", function(event) {
        if (!isDragging) return;

        offsetX = event.clientX - startX;
        offsetY = event.clientY - startY;

        updateTransform();
      });

      document.addEventListener("mouseup", function() {
        isDragging = false;
      });

      function updateTransform() {
        container.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
      }
    },
    closeLive2d() {
      this.live2dVisible = false;
    },
    coverGuide(cover, target) {
      // const body = document.body;
      const doc = document.documentElement;

      function clearRoundRect(context, x, y, width, height, radius) {
        context.save();
        context.beginPath();
        context.roundRect(x, y, width, height, radius);
        context.clip();
        context.clearRect(x, y, width, height);
        context.restore();
      }

      function clearArc(context, x, y, radius) {
        context.save();
        context.beginPath();
        context.arc(x, y, radius, 0, 2 * Math.PI, false);
        context.clip();
        context.clearRect(x - radius - 1, y - radius - 1, radius * 2 + 2, radius * 2 + 2);
        context.restore();
      }

      if (cover && target) {
        // target size(width/height)
        const targetWidth = target.clientWidth;
        const targetHeight = target.clientHeight;

        // page size
        const pageWidth = doc.clientWidth;
        const pageHeight = doc.clientHeight;

        // offset of target
        const offsetTop = target.getBoundingClientRect().top;
        const offsetLeft = target.getBoundingClientRect().left;

        // set size and border-width
        cover.style.width = pageWidth + "px";
        cover.style.height = pageHeight + "px";

        // 设置content位置
        const contentBox = this.$refs.guideContent;
        contentBox.style.top = offsetTop + "px";
        contentBox.style.left = offsetLeft + "px";
        contentBox.style.width = targetWidth + "px";
        contentBox.style.height = targetHeight + "px";

        const canvas = this.$refs.guideCanvas;
        const ctx = canvas.getContext("2d");
        canvas.width = pageWidth;
        canvas.height = pageHeight;
        // ctx.clearRect(0, 0, pageWidth, pageHeight);
        ctx.fillStyle = "rgba(0,0,0,0.75)";
        ctx.fillRect(0, 0, pageWidth, pageHeight);
        // 镂空区域
        clearRoundRect(ctx, offsetLeft, offsetTop, targetWidth, targetHeight, 24);
        ctx.beginPath();
        // 方型镂空区域增加背景
        ctx.fillStyle = "rgba(0,0,0,0.2)";
        ctx.roundRect(offsetLeft, offsetTop, targetWidth, targetHeight, 24);
        ctx.fill();
        ctx.closePath();
        // 镂空区域增加中心圆形镂空
        clearArc(ctx, offsetLeft + targetWidth / 2, offsetTop + targetHeight / 2 - 46, 53);

        // resize
        if (!cover.isResizeBind) {
          window.addEventListener("resize", () => {
            this.coverGuide(cover, target);
          });
          cover.isResizeBind = true;
        }
      }
    },
    onViewGuide() {
      document.body.style.overflow = null;
      this.hasViewZsca2Live2dGuide1 = true;
      localStorage.setItem("hasViewZsca2Live2dGuide1", true);
    },
    petalClick(event) {
      this.onViewGuide();
      // if (this.petalEffect) {
      //   this.petalEffect.handleClick(event);
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #e4e4e4;
  line-height: 14px;
  margin-top: -100px;

  img {
    width: 190px;
    height: 163px;
    margin-bottom: 7px;
  }
}

.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  color: #e4e4e4;
  line-height: 14px;

  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 20px;

    .item {
      display: inline-block;
      position: relative;
      box-sizing: border-box;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background: #4f6cc2;
      animation: ball-beat 0.7s -0.15s infinite linear;

      &:nth-child(2n-1) {
        animation-delay: -0.5s;
      }
    }

    @keyframes ball-beat {
      50% {
        opacity: 0.2;
        transform: scale(0.75);
      }

      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}

.live2d {
  position: relative;
  width: 100%;
  height: 100%;

  .container {
    position: relative;
    width: 100%;
    height: 100%;
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      .center {
        position: absolute;
        left: 50%;
        top: 200px;
        transform: translateX(-50%);
        display: block;
        width: 278px;
        height: 402px;
        border-radius: 50%;
        opacity: 0.25;
        filter: blur(60px);
      }
    }
    .lh-container {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100vh;
      overflow-y: hidden;
      text-align: center;

      img {
        margin-top: 50px;
        max-width: 911px;
        max-height: 911px;
        object-fit: contain;
      }
    }
  }

  .mask {
    cursor: url("~@/assets/zs_imgs/live2d_cursor.png"), pointer;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: #ffffff00;
    color: #ffffff00;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("~@/assets/zs_imgs/live2d-mask-bg.png") no-repeat;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      width: 640px;
      height: 100%;
      background: linear-gradient(180deg, #151618 0%, #171618 20%, #18191c 40%, #151416 100%);
      box-shadow: 0 0 20px #151618;
    }
  }
  .btns {
    position: absolute;
    right: 862px;
    top: 65px;
    z-index: 100;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 9px;
    .btn {
      display: inline-block;
      width: 28px;
      height: 28px;
      background: #394659;
      border-radius: 4px;
      cursor: pointer;

      .ai-draw {
        width: 20px;
        height: 20px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .cursor-guide-box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .live2d_animation {
      position: relative;
      width: 230px;
      height: 230px;
      overflow: hidden;

      .cursor-icon {
        will-change: transform, opacity;
        transform: translateZ(0);
        position: absolute;
        width: 230px;
        height: 230px;
        top: 0;
        left: 0;
        background: url("~@/assets/zs_imgs/live2d_guide.png") no-repeat;
        background-size: 22540px 230px;
        animation: spriteAnimation 3s steps(98) infinite;
      }

      @keyframes spriteAnimation {
        from {
          background-position: 0 0;
        }
        to {
          background-position: -22540px 0;
        }
      }
    }
  }
}

/deep/ #__spine_player_container__ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  img {
    margin-top: 50px;
    max-width: 911px;
    max-height: 911px;
    object-fit: contain;
  }
}

/deep/ .lh-dialog {
  background-color: rgba(0, 0, 0, 0.77);

  .el-dialog__header {
    position: relative;
    padding: 0;
    margin: 0 auto;
    width: 1000px;

    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }

    .el-icon-close {
      color: #fff;
    }
  }

  .el-dialog__body {
    padding: 0;
  }

  .lh-container {
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    text-align: center;

    img {
      height: 100%;
    }
  }
}

/deep/ .live2d-dialog {
  background-color: rgba(0, 0, 0, 0.9);

  .el-dialog__header {
    position: relative;
    padding: 0;
    margin: 0 auto;
    width: 1000px;

    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }

    .el-icon-close {
      color: #fff;
    }
  }

  .el-dialog__body {
    padding: 0;
  }

  .live2d-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    text-align: center;
  }
}

/deep/ .video-dialog {
  background-color: rgba(0, 0, 0, 0.9);
  .el-dialog__header {
    padding: 0;
    position: relative;
    margin: 0 auto;
    width: 1000px;
    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
    .el-icon-close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .video-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    overflow: hidden;
    video {
      width: 960px;
    }
  }
}

.guide-box {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;

  canvas {
    width: 100%;
    height: 100%;
  }

  .guide-content {
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 320px;

    .click-icon {
      width: 55px;
      height: 70px;
      margin-bottom: 25px;
    }

    .line-icon {
      width: 3px;
      height: 181px;
      margin-bottom: 11px;
    }

    .dot {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #757474;
      border-radius: 50%;
      margin-bottom: 16px;

      &::after {
        content: "";
        display: block;
        width: 8px;
        height: 8px;
        background: #fff;
        border-radius: 50%;
      }
    }

    .tips {
      font-weight: bold;
      font-size: 22px;
      color: #ffffff;
      line-height: 23px;
      margin-bottom: 29px;
    }

    .btn {
      width: 134px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(123, 213, 255, 0.5);
      border-radius: 20px;
      font-weight: 400;
      font-size: 16px;
      color: #82fff8;
      cursor: pointer;
    }
  }
}
</style>
